var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loading)?_c('fusioncharts',{ref:_vm.id,attrs:{"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataformat":_vm.dataFormat,"datasource":_vm.dataSource}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }